/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

const WARNING_CODES = {
  LEGACY_CONFIG_COMPONENT_USED: {
    code: 'W3001',
    template: 'You are using the legacy {legacySelector} configuration component. Please upgrade to '
      + 'our new {replacement} configuration component. Upgrade instructions:\n\n'
      + '  https://js.devexpress.com/Angular/Documentation/Guide/Common/DevExtreme_CLI/#Migrate_to_Named_Configuration_Components',
  },
} as const;

export type WarningId = keyof typeof WARNING_CODES;
export type WarningDefinition = typeof WARNING_CODES[WarningId];

export default WARNING_CODES;
